var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdsCategories01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n        stroke-width: 0.75px;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Ads Categories") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1.5,
    y: 1.9,
    width: 9.18,
    height: 9.18,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1.5,
    y: 13.13,
    width: 9.18,
    height: 9.18,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.97,
    y: 1.9,
    width: 9.18,
    height: 9.18,
    rx: 2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 17.52,
    cy: 17.46,
    r: 4.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 20.83,
    y1: 20.45,
    x2: 22.5,
    y2: 22.45
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdsCategories01);
export default __webpack_public_path__ + "static/media/Ads_Categories_01.0fc7e5011f9f5d0e66847f181e423418.svg";
export { ForwardRef as ReactComponent };